import { Logger, fillValues } from 'DVWebNodeUtils'
import { StringId } from '../components/localizer/stringId'
import { IStringMap, IReplaceObj } from '../selectors/string';
import * as WpsRuntime from 'DVWebNodeWpsRuntime'

export type DVStringAttrs = { [key: string]: { [key: string]: string } }

type GetStringFromId = {
  strings: IStringMap
  stringId: StringId
  logger: Logger
  replace?: IReplaceObj
}

export const buildDvString = (string: string, attrs: DVStringAttrs = {}) => ({
  string,
  attrs
})

export const getStringFromId = ({
  strings,
  stringId,
  replace,
  logger
}: GetStringFromId) => fillValues(strings[stringId], replace, logger)


export const getStringClosure = (strings: IStringMap, logger: Logger) => (
  stringId: StringId,
  replace?: IReplaceObj
) => getStringFromId({ strings, stringId, replace, logger })
export type IGetString = ReturnType<typeof getStringClosure>

export const convertToDVString = (s: string | WpsRuntime.atv.wps.DVString): WpsRuntime.atv.wps.DVString => {
  if (typeof s === 'string') {
    return buildDvString(s.trim()) as WpsRuntime.atv.wps.DVString
  } else {
    return s
  }
}